/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, DownloadService, HttpService } from '@dm/core';
import { type Observable } from 'rxjs/internal/Observable';

import { EXPORT_LOG_ENCRYPTED_VALUE, STREAMLINE_DIAGNOSTIC_QUERY_BEFORE_EXPORT_TAG } from '../export.const';

@Injectable()
export class StreamlineDiagnosticService {
    constructor(
        private httpService: HttpService,
        private downloadService: DownloadService,
    ) { }

    /**
     * 收集精简诊断信息
     */
    collectStreamlineDiagnostic(isEncryption: boolean, options: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('streamlineDiagnostic.collect', 'V2');
        const params = {
            encryption: EXPORT_LOG_ENCRYPTED_VALUE,
        };

        // 如果不加密不传相应参数
        if (!isEncryption) {
            return this.httpService.get(rest);
        }
        rest.setParams(params);
        return this.httpService.get(rest, options);
    }

    /**
     * 导出精简诊断信息
     */
    exportStreamlineDiagnostic(fileName): Observable<boolean> {
        const rest = this.httpService.makeUrl('streamlineDiagnostic.export', 'V2');
        return this.downloadService.download(rest, fileName);
    }

    /**
     * 精简诊断信息文件导出前查询
     */
    queryExportStreamlineDiagnostic(): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('streamlineDiagnostic.export', 'V2');
        rest.setParams({ tag: STREAMLINE_DIAGNOSTIC_QUERY_BEFORE_EXPORT_TAG });
        return this.httpService.get(rest);
    }

    /**
     * 查询精简诊断信息
     */
    queryStreamlineDiagnostic(): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('streamlineDiagnostic.query', 'V2');
        return this.httpService.get(rest);
    }
}
